import axios from "axios";
import { headersProvider } from "../pages/utilities";

// Extract obligations from a document using AI model(openai/gemini)
// export const processDocument = async ({ signedUrl, aggrementNum }) => {
//   const response = await fetch(
//     `${process.env.REACT_APP_API_URL}/api/ai/extract`,
//     {
//       method: "POST",

//       headers: headersProvider(),

//       body: JSON.stringify({
//         file_path: signedUrl,
//         document_type: "ob_prompt", // specify the type of document
//         model: "openai",
//         extract_id: aggrementNum,
//       }), // str
//     }
//   );

//   if (!response.ok) {
//     const errorData = await response.json();
//     throw new Error(errorData.detail || "API error");
//   }

//   return response.json();
// };

export const processDocument = async ({
  signedUrl,
  aggrementNum,
  document_type,
  client_name,
  brand_name,
  file_extension,
}) => {
  return axios
    .post(
      `${process.env.REACT_APP_API_URL}/api/ai/extract`,
      {
        file_path: signedUrl,
        document_type: document_type, // specify the type of document
        model: "openai",
        extract_id: aggrementNum + "",
        contents: {
          client_name: client_name + "",
          brand_name: brand_name + "",
          file_extension: file_extension + "",
        },
      },
      {
        headers: headersProvider(),
      }
    )
    .then((response) => response.data)
    .catch((error) => {
      console.error("There was an error in extracting obligations", error);
      throw error;
    });
};

export const getDocumentStatus = async ({ taskId }) => {
  return axios
    .get(`${process.env.REACT_APP_API_URL}/api/ai/extract-status/${taskId}`, {
      headers: headersProvider(),
    })
    .then((response) => response.data)
    .catch((error) => {
      console.error("There was an error getting task details", error);
      throw error;
    });
};
// Get the status of the obligation extraction task
// export const getDocumentStatus = async (taskId) => {
//   const response = await fetch(
//     `${process.env.REACT_APP_API_URL}/api/ai/extract-status/${taskId}`, headers: headersProvider()
//   );

//   if (!response.ok) {
//     throw new Error("Failed to get document processing status");
//   }

//   return response.json();
// };
